export function initAccordions() {
  if (document.body.classList.contains('neos-backend')) return;
  document.querySelectorAll('.c-accordion-entry').forEach(initAccordion);
}

function initAccordion(item) {
  // Cache the latest animation object to prevent stacking of animations
  let currentAnimation = null;

  // Handle clicks on the summary bar (title of the accordion item)
  item.querySelector('summary').addEventListener('click', (e) => {
    // Query the current height and check if the item is currently open
    const currentHeight = item.clientHeight;
    const closing = item.hasAttribute('open');

    // Cancel the action if an animation is already running or if the item is pinned open
    if (currentAnimation) {
      e.preventDefault();
    } else {
      // Wait for the inherent action (opening/closing) to complete
      requestAnimationFrame(() => {
        // Query the new item height and animate from the old to the new height
        const targetHeight = item.clientHeight;
        currentAnimation = item.animate(
          [
            { height: `${currentHeight}px`, offset: 0 },
            { height: `${targetHeight}px`, offset: 1 },
            { height: 'auto', offset: 1 },
          ],
          { easing: 'ease-in-out', fill: 'forwards', duration: 500 }
        );

        // Set the open attribute; we need to do this as the item must be "open" during the animation
        // regardless of it opening or closing. We set different attribute values to distinguish these
        // cases in CSS
        item.setAttribute('open', closing ? 'closing' : 'open');

        // Handler for the animation finish; removes the "open" attribute on closing and removed the
        // cached animation object
        currentAnimation.addEventListener('finish', () => {
          if (closing) item.removeAttribute('open');
          currentAnimation = null;
        });
      });
    }
  });

  window.addEventListener('beforeprint', () => item.setAttribute('open', ''));
  window.addEventListener('afterprint', () => item.removeAttribute('open'));
}
